import React from 'react';
import { AppSection, AppTitle } from '../Conditions/Conditions';
import { Container } from 'react-bootstrap';
import { FeedbackSlider } from '../../components';
import styled from 'styled-components';
import { Link } from 'react-scroll';
import { BsArrowRight } from 'react-icons/bs';

const FeedbackFranchise = () => {
  return (
    <AppSection className="feedback-franchise">
      <Container>
        <AppTitle>Отзывы действующих франчайзи</AppTitle>
        <FeedbackSlider />
        <Link to="contact-form">
            <WelcomeButton>
            Получить презентацию
              <Arrow />
            </WelcomeButton>
          </Link>
      </Container>
    </AppSection>
  );
};

const WelcomeButton = styled.button`
  display: flex;
  align-items: center;
  background: #ffdc00;
  border: 2px solid #ffdc00;
  border-radius: 8px;
  padding: 20px 28px 20px 32px;
  color: #26292d;
  font-weight: 700;
  font-size: 20px;
  margin-top: 4rem;
  &:hover {
    background: #fff199;
    border: 2px solid #ffdc00;
  }
  @media (max-width: 1440px) {
    margin-top: 3rem;
  }
  @media (max-width: 1135px) {
    margin-top: 4rem;
  }
  @media (max-width: 600px) {
    width: 382px;
    font-size: 20px;
  }
  @media (max-width: 480px) {
    width: 100%;
    font-size: 20px;
    padding: 20px 11px 20px 11px;
    display: flex;
    justify-content: center;
  }
`;

const Arrow = styled(BsArrowRight)`
  margin-left: 15px;
  @media (max-width: 480px) {
    margin-left: 5px;
  }
`;

export default FeedbackFranchise;
